import React from 'react';
import services from '../../../../services';

class VinicaRightTabLI extends React.Component {

    /* Primeiro passo na acomodação da classe */

    constructor(props) {
        super(props);
        this.state = {
            entity_row: {}
        }
    }

    /* Esta é a primeira etapa após o construxctor para carregar este componente  */

    componentDidMount() {
        this.setEntityList()
        console.log("the mount of li component")
    }

    componentDidUpdate(prevProps) {
        if (prevProps.date !== this.props.date) {
            this.setEntityList()
            console.log("update is running li")
        }
    }

    setEntityList=()=>{
        let nif = ""
        if(!this.props.entity){
            this.getEntityList();
            console.log("set Entity list API call")
        }
        else {
            let entity = {}
            if(this.props.entity) {
                nif = this.props.entity.nif
                entity[nif] = this.props.entity
                this.setState({
                    entity_row: entity,
                    nif 
                },() => {
                    console.log("without call", this.state.entity_row)
                })
            }
        }
    }

    getEntityList = async () => {
        this.setState({
            entity_row: {}
        })
        let res = await services.EntityList.getEntityList('parcel', null, this.props.nif + '')
        this.setState({
            entity_row: res.entity_row,
            nif: this.props.nif
        }, () => {
            this.props.getDisplayData(this.state.entity_row[this.props.nif], this.props.tab)
        })
    }

    /*  Para renderizar o conteúdo html da página   */

    render() {
        return (
            Object.keys(this.state.entity_row).length > 0 &&
            <li className="align-items-center p-2" style={this.props.tab === 'Utilizadores' ? {borderBottom: "1px solid lightGrey"} : {}}>
                {
                    this.state.entity_row && 
                    this.state.entity_row[this.state.nif] && 
                    <span>
                        <p className="m-0 text-left parcelholdername">
                            {
                                this.state.entity_row[this.state.nif].nome
                            }
                        </p>
                        <p className="small m-0 text-left parcelholdernumber">
                            {
                                this.state.entity_row[this.state.nif].nif
                            }
                        </p>
                        {   this.props.entity.entidadePrincipal == true && 
                            // this.state.entity_row[this.state.nif].nif===this.props.IdenUser[this.props.tab] && 
                            <p style={{marginTop:"5px", width: "100px"}} className="titular-tag">Ident. Propriétario</p>
                        }
                    </span>
                }
                <span className="cursor-pointer" onClick={() => this.props.detailClick(this.state.entity_row && this.state.entity_row[this.state.nif])} data-toggle="modal" data-target='#vinica-left-detail-popup'>
                    <i className="fas fa-exclamation-circle" aria-hidden="true"></i>
                </span>
            </li>
        )
    }
}

export default VinicaRightTabLI;